import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useDashboard } from '../context/DashboardContext';
import { useDashboardProfile } from '../context/DashboardProfileContext';
import { getModuleConfig } from '../config';
import { AccountDialog } from './AccountDialog';

export function ModuleToolbar() {
  const { activeModule } = useDashboard();
  const { user } = useAuth();
  const { profile } = useDashboardProfile();
  const [accountOpen, setAccountOpen] = useState(false);
  const config = getModuleConfig(activeModule);
  const Icon = config.icon;

  const displayName =
    profile?.nome || user?.displayName || user?.email?.split('@')[0]?.replace(/\./g, ' ') || 'Pesquisador';

  return (
    // sm:h-16 alinha com a linha do cabeçalho da sidebar (também h-16) — mesma
    // altura dos dois lados, sem precisar de uma segunda linha divisória aqui.
    <header className="shrink-0 px-6 py-4 sm:h-16 sm:py-0 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-start gap-3 min-w-0">
        <div className="shrink-0 w-9 h-9 rounded-full bg-primary/10 flex items-center justify-center">
          <Icon className="h-[18px] w-[18px] text-primary" />
        </div>
        <div className="min-w-0">
          <h1 className="text-base font-semibold text-foreground leading-tight">
            {config.label}
          </h1>
          <p className="text-xs text-muted-foreground mt-0.5 truncate">
            {config.description}
          </p>
        </div>
      </div>

      <button
        type="button"
        onClick={() => setAccountOpen(true)}
        title="Minha conta"
        className="flex items-center gap-3 shrink-0 rounded-full hover:opacity-80 transition-opacity"
      >
        {profile?.fotoUrl ? (
          <img src={profile.fotoUrl} alt="" className="w-8 h-8 rounded-full object-cover shrink-0" />
        ) : (
          <div className="w-8 h-8 rounded-full bg-primary/15 flex items-center justify-center text-xs font-semibold text-primary uppercase shrink-0">
            {displayName.charAt(0)}
          </div>
        )}
        <div className="hidden sm:block min-w-0 text-left">
          <p className="text-sm font-medium text-foreground truncate capitalize">
            {displayName}
          </p>
          <p className="text-[11px] text-primary font-medium truncate max-w-[160px]">
            Ver minha conta
          </p>
        </div>
      </button>

      <AccountDialog open={accountOpen} onOpenChange={setAccountOpen} />
    </header>
  );
}
